module.exports = __webpack_public_path__ + "img/ring_y_c_null_1@3x.9995258a.png";